<template>
  <v-container class="pa-0">
    <!-- nagłówek karty  -->
    <v-card class="mb-2 ">
      <v-card-title class="py-0 px-0">
          <v-card class="m0" color="primary" dark style="width: 100%">
            <v-card-title class="pt-0 pb-2 pl-2 pr-1">
              <span class="title font-weight-bold"
                >{{ $t("ComplaintsList.TopicComplaintList") }}
              </span>
              <v-spacer></v-spacer>
                <v-icon
                  color="blue darken-1" 
                  @click="closeComplaintList()"
                  >mdi-close
                </v-icon>
            </v-card-title>
            <v-card-subtitle
              class="pb-0 pb-sm-2 pl-2" 
            >
              {{ $t("ComplaintsList.TopicComplaintListDescription") }}
            </v-card-subtitle>
          </v-card>
      </v-card-title>
    </v-card>

    <!-- Filtr wyszukiwania -->
    <v-card class="">
      <v-card-text 
        v-if="showFilter"
        outlined 
        class="pb-0 grey lighten-5"
      > 
        <v-row>
          <!-- Filtr: data od -->
          <v-col cols="6" sm="2" class="py-0">

            <v-menu
              v-model="menuStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field 
                  class="py-0 py-sm-1"
                  v-model="startDate"
                  :label="lblDateFrom"
                  append-icon="mdi-calendar"
                  @click:append="menuStartDate = true"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>

              <v-date-picker
                v-model="startDate"
                :locale="lang"
                @input="menuStartDate = false"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <!-- Filtr: data do -->
          <v-col cols="6" sm="2" class="py-0">
            <v-menu
              v-model="menuEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="py-0 py-sm-1"
                  v-model="endDate"
                  :label="lblDateTo"
                  append-icon="mdi-calendar"
                  @click:append="menuEndDate = true"
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                :locale="lang"
                @input="menuEndDate = false"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>
          
          <!-- Filtr: klient -->
          <v-col  cols="12" sm="3" class="py-0" >
              <v-text-field 
                v-if="this.privileges > 0"
                class="py-0 py-sm-1"
                v-model="filterCustomer"
                :label="lblCustomer"
                @keydown.enter="refreshDocList"
              >
              </v-text-field>
          </v-col>
          
          <!-- Filtr: Pzycisk 'Odswież' -->
          <v-col cols="12" sm="5" class="py-0 text-sm-right text-center">
            <v-btn 
              class="mb-2 mt-sm-1" 
              dark
              color="green"
              @click = "refreshDocList()"
              @keydown.enter="refreshDocList"
              :loading="loading"
            >
              {{ $t("Refresh") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      
      <!-- Ukrywanie filtra: odkryty -->
      <v-card-text 
        v-if="showFilter"
        class="px-4 pt-0 pb-2 grey lighten-5 d-flex justify-end"
      >
        <v-checkbox 
          v-model="autoHideFilter" 
          class="ma-0 pa-0"
          hide-details
        > 
          <template v-slot:label messages:false>
            <div class="caption pr-2">
              {{ $t("Autohide") }} 
            </div>
            <v-btn 
              v-show="!autoHideFilter"
              @click="showFilter=!showFilter"
              x-small
            >{{ $t("HideFilter") }}
              <v-icon small>mdi-filter-minus-outline</v-icon>
            </v-btn>
          </template>
        </v-checkbox>
        </v-card-text> 


      <!-- Pokazywanie filtra: ukryty -->      
      <v-card-text 
        class="px-4 pt-2 pb-2 grey lighten-5"
        align="right"
        v-else
      >
        <v-btn 
          @click="showFilter=!showFilter"
          x-small
        >
          {{ $t("ShowFilter") }}
          <v-icon small>mdi-filter-plus-outline</v-icon>
        </v-btn>
      </v-card-text>
      <v-alert
          :value="alertGetData"
          dark
          type="info"
          transition="scale-transition"
        >
          {{ $t("Loading") }}
      </v-alert>
    </v-card>

    <!-- odczytane dane  -->
    <v-card-text class="pt-0 my-0"
      v-if="ComplaintsDocumentsList.length > 0"
    >
      <v-text-field
        class="pt-0"
        v-model="search"
        append-icon="mdi-magnify"
        v-bind:label="lblSearch"
        click:row
        single-line
        hide-details
      ></v-text-field>
    </v-card-text>

    <v-card 
      v-if="ComplaintsDocumentsList.length > 0" 
      background-color="white" 
      color="primary"
    >
      
      <!-- tabela reklamacji sm i wyżej -->
      <v-card>
        
        <v-card
          v-if="$vuetify.breakpoint.smAndUp"
        >
          <v-data-table
            
            :headers="headerComplaintsView"
            :items="ComplaintsDocumentsList"
            :search="search"
            class="elevation-1"
            @click:row="openDialogComplaintDocument"
            item-key="idx"
            :sort-by="['hasNotice', 'issueDate', 'documentNumber.documentFullName']"
            :sort-desc="[true, true, true]"
            :loading="loading"
            v-bind:loading-text="LblLoading"
            multi-sort

            hide-default-footer
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
          >
          
            <template slot="headers" slot-scope="props">
              <tr class="grey lighten-3">
                <th>
                  <v-icon>mdi-filter-list</v-icon>
                </th>
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                    <v-select
                      flat
                      hide-details
                      small
                      multiple
                      clearable
                      :items="columnValueList(header.value)"
                      v-model="mainCustomer.code"
                    ></v-select>
                  </div>
                </th>
              </tr>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <v-icon>{{ getStateIco(item.status) }}</v-icon>
            </template>
            <template v-slot:[`item.issueDate`]="{ item }">
              {{ dateFormat(item.issueDate) }}
            </template>

            <template v-slot:[`item.targetCustomer.name`]="{ item }">
                {{item.targetCustomer.name  != item.mainCustomer.name ? item.targetCustomer.name : '' }}
            </template>
            
            <template v-slot:[`item.complaintStatus`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-big
                    :color="
                      getcomplaintStatusColor(
                        item.complaintStatus,
                        item.status,
                        item.hasNotice
                      )
                    "
                    dark
                    v-bind="attrs"
                    v-on="on"
                    >{{
                      getfirstLetterFromString($t(
                        getcomplaintStatus(
                          item.complaintStatus,
                          item.status,
                          item.hasNotice
                        )
                      ))
                    }}
                  </v-chip>
                </template>
                  <div>
                    {{
                      $t(
                        getcomplaintStatus(
                          item.complaintStatus,
                          item.status,
                          item.hasNotice
                        )
                      )
                    }}
                  </div>
              </v-tooltip>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination 
              v-model="page" 
              :length="pageCount"
              :total-visible="5"
            ></v-pagination>
          </div>
        </v-card>
        
        <!-- tabela reklamacji poniżej sm  -->
        
        <v-card
          v-else
        >  
          <!-- FAB button GoToTOP -->
           <v-fab-transition>
            <v-btn
              v-scroll="onScroll"
              v-show="showScroll"
              fab
              dark
              fixed
              bottom
              right
              color="red"
              @click="toTop" 
            >
              <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
           </v-fab-transition>
         

          <v-data-table
          
            :headers="headerComplaintsView"
            :items="ComplaintsDocumentsList"
            :search="search"
            class="elevation-1"
            @click:row="openDialogComplaintDocument"
            item-key="idx"
            :loading="loading"
            v-bind:loading-text="LblLoading"
            :sort-by="['hasNotice', 'issueDate', 'documentNumber.documentFullName']"
            :sort-desc="[true, true, true]"
            multi-sort
            hide-default-header
            hide-default-footer
            dense

           disable-pagination

          >
          
            <template slot="headers" slot-scope="props">
              <tr class="grey lighten-5">
                <th>
                  <v-icon>mdi-filter-list</v-icon>
                </th>
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)">
                    <v-select
                      flat
                      hide-details
                      small
                      multiple
                      clearable
                      :items="columnValueList(header.value)"
                      v-model="mainCustomer.code"
                    ></v-select>
                  </div>
                </th>
              </tr>
            </template>
            
            <template v-slot:[`item.status`]="{ item }">
              <v-icon>{{ getStateIco(item.status) }}</v-icon>
            </template>
            
            <!-- Data reklamacji - Zmiana formatu wyswiatlania daty -->
            <template v-slot:[`item.issueDate`]="{ item }">
              {{ dateFormat(item.issueDate) }}
            </template>
            
            <!-- Status - zamiana stanu tekstowego na ikone -->
            <template v-slot:[`item.complaintStatus`]="{ item }">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    x-small
                    :color="
                      getcomplaintStatusColor(
                        item.complaintStatus,
                        item.status,
                        item.hasNotice
                      )
                    "
                    dark
                    v-bind="attrs"
                    v-on="on"
                    >{{
                      getfirstLetterFromString($t(
                        getcomplaintStatus(
                          item.complaintStatus,
                          item.status,
                          item.hasNotice
                        )
                      ))
                    }}
                  </v-chip>
                </template>
                  <div>
                    {{  
                      $t(
                        getcomplaintStatus(
                          item.complaintStatus,
                          item.status,
                          item.hasNotice
                        )
                      )
                    }} 
                  </div>
              </v-tooltip>
            </template>
          </v-data-table>
        
        </v-card>
            
      </v-card>
      
    </v-card>
    

    <!-- ComplaintDocument dialog -->
    <v-dialog
      v-if="ComplaintDocument != null"
      v-model="showDialogComplaintDocument"
      scrollable
      max-width="90%"
      @keydown.esc="closeDialogComplaintDocument()"
      tabindex="0"
    >
      <v-card
        class="flexcard" height="90vh">
        <!-- Nagłówek pozycji reklamacji -->
        <v-card-title class="pa-1">
            <v-card color="primary" dark style="width: 100%">
              <v-card-title class="pt-0 pb-2 pl-2 pr-1">
                <span class="title font-weight-bold">
                  {{ ComplaintDocument.documentNumber.documentFullName }}
                </span>
                <v-spacer></v-spacer>
                <v-icon
                  color="blue darken-1" 
                  @click="closeDialogComplaintDocument()"
                  >mdi-close
                </v-icon>
              </v-card-title>
              <v-card-subtitle class="pb-0 pb-sm-2">
                {{ $t("ComplaintsList.ComplaintDocument.FromDay") }}: {{ ComplaintDocument.issueDate.slice(0, 10) }}
              </v-card-subtitle>
            </v-card>
          
        </v-card-title>

        <!-- Zawartość pozycji / dane nagłówka -->
        <v-card class="elevation-0">
          <v-container fluid class="py-0">
            <v-row no-gutters>
              <!-- klient -->
              <v-col class="col-8 col-sm-8 text-left pl-2 py-0 my-0">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-title class="justify-start">
                     <v-btn
                        fab
                        small
                        class="pa-0"
                        @click="openDialogHeaderBinaryList()"
                        text
                        v-if="ComplaintDocument.binariesDataList.length > 0"
                      >
                        <v-icon small>
                            mdi-paperclip
                        </v-icon>
                      </v-btn>
                      
                      <v-btn
                        fab
                        small
                        class="pa-0"
                        @click="openDialogInstalationAddress()"
                        text
                        v-if="instalationAddres.length > 0"
                      >
                        <v-icon small>
                          mdi-home-city
                          </v-icon>
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <!-- ikony -->
              <v-col
                class="col-4 col-sm-4 text-right text-sm-right mb-0 mb-sm-0 pr-0 py-0 my-0"
              >
                <v-list-item class="px-0">
                  <v-list-item-content class="pa-0">
                    <v-list-item-title class="title">
                      <v-icon>
                        {{ getStateIco(ComplaintDocument.status) }}
                      </v-icon>
                    </v-list-item-title>

                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>

            <!-- adres dostawy -->
            <v-dialog
              v-model="showDialogInstalationAddress"
              scrollable
              max-width="300px"
              hide-overlay
            >
              <v-card>
                <v-card-title 
                  class="pa-1"
                  v-if="instalationAddres.length > 0"    
                >
                  <v-col cols="12" class="pa-0">
                    <v-card class="m0" color="primary" dark>
                      <v-card-title class="pt-0 pb-2">
                        <span class="title font-weight-bold"
                          >{{ $t("ComplaintsList.ComplaintDocument.InspectionAddress.TopicInspectionAddress") }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn 
                          icon
                          color="blue darken-1" 
                          @click="closeDialogInstalationAddress()"
                        > 
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-card-title>
                
                <v-container v-if="instalationAddres.length > 0" fluid>
                  <v-textarea
                    class="caption text-justify py-0 my-0"
                    auto-grow
                    readonly
                    v-model="instalationAddres"
                    rounded
                    dense
                    rows="3"
                  ></v-textarea>
                </v-container>
              </v-card>
            </v-dialog>

            <!-- lista załączników -->
            <v-dialog
              v-model="showDialogHeaderBinaryList"
              scrollable
              max-width="50vw"
              hide-overlay
            >
            
              <v-card>
                 <v-card-title 
                  class="pa-1"
                  v-if="binariesDataList.length > 0"    
                >
                  <v-col cols="12" class="pa-0">
                    <v-card class="m0" color="primary" dark>
                      <v-card-title class="pt-0 pb-2 pl-2 pr-1">
                        <span class="title font-weight-bold"
                          >{{ $t("ComplaintsList.ComplaintDocument.Attachments.TopicAttachments") }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-icon
                          color="blue darken-1" 
                          @click="closeDialogHeaderBinaryList()"
                        >mdi-close
                        </v-icon>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-card-title>

                <v-container v-if="binariesDataList.length > 0" fluid>
                  <v-row>
                    <v-col
                      v-for="item in binariesDataList"
                      :key="item.idx"
                      class="d-flex child-flex"
                      cols="4"
                    >
                      <v-hover 
                        v-slot:default="{ hover }"
                        :key="item.idx"
                      >
                      <v-card 
                        @click="openDialogFullAttachment(item)"
                          :elevation="hover ? 4 : 0"
                      >
                        <v-img
                          v-if="item.typeId == 858 || item.typeId == 859"
                          src="../../assets/pdf.png"
                          lazy-src="../../assets/pdf.png"
                          aspect-ratio="1.4"
                          class="grey lighten-5"
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                          v-else
                          :src=  "dataImageUrl(item.data)"
                          :lazy-src="dataImageUrl(item.data)"
                          aspect-ratio="1.4"
                          class="grey lighten-5"
                          contain
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                  
                </v-container>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="showDialogFullAttachment"
              v-if="this.dataFullAttachment != null"
              @keydown.esc="closeDialogFullAttachment()"
            >
              <v-card 
                class="pt-0 pb-0"
              >
                <v-card-title
                class="pt-0 pb-0"
                > 
                  <v-spacer></v-spacer>
                  <v-card
                    class="elevation-0"
                    v-if="this.dataFullAttachment.typeId == 858 || this.dataFullAttachment.typeId == 859"
                  >
                    <v-btn 
                      icon
                      @click="currentPagePDF--"
                      :disabled="pageCountPDF==1 || currentPagePDF==1"
                    >
                      <v-icon>mdi-arrow-left-thick</v-icon>
                    </v-btn>
                    {{currentPagePDF}} / {{pageCountPDF}}
                    <v-btn 
                      icon
                      @click="currentPagePDF++"
                      :disabled="pageCountPDF==1 || currentPagePDF==pageCountPDF"
                    >
                      <v-icon>mdi-arrow-right-thick</v-icon>
                    </v-btn>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-card-actions>
                    <v-btn 
                      icon
                      @click="saveAttachmentToDisc()"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                    <v-btn 
                      icon
                      @click="closeDialogFullAttachment()"
                    > 
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card-title>
                <div
                  v-if="this.dataFullAttachment.typeId == 858 || this.dataFullAttachment.typeId == 859"
                >
                  <pdf
                    :src="getAttachmentData('PDF')"
                    :page="currentPagePDF"
                    @num-pages="pageCountPDF = $event"
                    @page-loaded="currentPagePDF = $event"
                    style="display: inline-block; width: 100%"
                    ref="myPdfComponent"
                  >
                  </pdf>
                </div>
                <div v-else>
                  <v-img
                    :src="getAttachmentData('IMG')"
                  ></v-img>
                </div>
              </v-card>
            </v-dialog>

          <!-- dane dealera-->
          <v-card outlined>
          <v-card-title class="subtitle-2 pl-1 pt-3 pb-0">
            {{ $t("ComplaintsList.ComplaintDocument.Dealer") }} / {{ $t("ComplaintsList.ComplaintDocument.targetCustomer") }}:
          </v-card-title>
            <v-card-text class="py-0 px-0 pl-3 pt-0">
              <v-row >
                <v-col class="py-0">
                  {{ ComplaintDocument.mainCustomer.name }}   
                </v-col>
              </v-row>
              <v-row v-if="ComplaintDocument.mainCustomer.name != ComplaintDocument.targetCustomer.name">
                <v-col class="py-0">
                  {{ ComplaintDocument.targetCustomer.name }}   
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- opis reklamacji-->
          <v-card-title class="subtitle-2 pl-1 pt-3 pb-1">
           {{ $t("ComplaintsList.ComplaintDocument.ComplaintDescription") }} :
          </v-card-title>
            <v-card-text 
              class="py-0 px-0"
             >
                  <v-card outlined class="py-0 my-0 grey lighten-5" id="aaa">
                    <v-list-item class="px-1">
                      <v-list-item-content class="py-0 px-0 my-0">
                        <v-textarea
                          v-if="(ComplaintDocument.description.length > this.getComplaintDescriptionLettersCount() || ComplaintDocument.description.indexOf('\n') > 0) && showRealizationDescriptionFull"
                          class="caption text-justify py-0 my-0"
                          auto-grow
                          readonly
                          v-model="ComplaintDocument.descriptionSmall"
                          rounded
                          rows="0"
                          hide-details
                        ></v-textarea>
                        <v-textarea
                          v-else
                          class="caption text-justify py-0 my-0"
                          auto-grow
                          readonly
                          v-model="ComplaintDocument.description"
                          rounded
                          rows="0"
                          hide-details
                        ></v-textarea>
                        <v-list-item-subtitle class="overline elevation-0 pl-3">
                          <!-- {{ $t("ComplaintsList.ComplaintDocument.ComplaintDescription") }} -->
                          <v-card-actions 
                            v-if="ComplaintDocument.description.length > this.getComplaintDescriptionLettersCount() || ComplaintDocument.description.indexOf('\n') > 0"
                            class="elevation-0 pt-0 pl-5"
                          >
                          <v-btn
                            small
                            icon
                            @click="showRealizationDescriptionFull = !showRealizationDescriptionFull"
                          >
                            {{ lblBtnMore }}

                            <v-icon>
                              {{ showRealizationDescriptionFull ? "mdi-chevron-down" : "mdi-chevron-up" }}
                            </v-icon>
                          </v-btn>
                        </v-card-actions>
                        </v-list-item-subtitle>

                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
            </v-card-text>
            <!-- koniec nagłówka -->
          </v-container>
        </v-card>
        
        <v-card 
          class="elevation-0 pl-5 pr-3 pb-1 pt-0 overflow-y-auto"
              scrollable
          >
          
          <!-- pozycje reklamacji-->
          <v-card-title class="subtitle-2 pl-0 pt-3 pb-1">
            {{ $t("ComplaintsList.ComplaintDocument.AppliesToItem") }} :
          </v-card-title>

          <template v-for="item in ComplaintDocument.elementsList">
            <v-hover 
              v-slot:default="{ hover }"
              :key="item.idx"
            >
            
              <v-card
                :key="item.idx"
                outlined
                class="mt-1"
                @click="showDialogPositionRealization(item)"
                :elevation="hover ? 4 : 0"
              >
              
                <v-card-title class="subtitle-1 pt-1">
                  {{ item.article.code }}
                  <v-spacer></v-spacer>
                  <v-icon small v-if="item.binariesDataList.length > 0"
                    >mdi-paperclip</v-icon
                  >

                  <v-chip
                    x-small
                    :color="
                      getcomplaintStatusColor(
                        item.status,
                        ComplaintDocument.status,
                        item.hasNotice
                      )
                    "
                    dark
                    >{{
                      $t(
                        getcomplaintStatus(
                          item.status,
                          ComplaintDocument.status,
                          item.hasNotice
                        )
                      )
                    }}</v-chip
                  >
                </v-card-title>
                <v-card-subtitle class="pb-2">
                  {{ item.article.name }}
                </v-card-subtitle>
              </v-card>
            </v-hover>
          </template>
        </v-card>
        <!-- Koniec listy pozycji -->

        <!-- Okienko z lista realizacji -->
        <v-dialog
          v-if="currentComplaintPosition"
          v-model="showDialogRealizationsList"
          scrollable
          max-width="90%"
          @keydown.esc="closeDialogPositionRealization"
          open-on-hover
        > 
       <v-card>
        <v-card-title class="pa-1">
          <v-card color="primary" dark style="width: 100%">
            <v-card-title class="pt-0 pb-2 pl-2 pr-1">
              <span class="title font-weight-bold">
                {{ currentComplaintPosition.article.code }}
              </span>
              <v-spacer></v-spacer>
              <v-icon 
                color="blue darken-1" 
                @click="closeDialogPositionRealization()"
              >mdi-close
              </v-icon>
            </v-card-title>
            <v-card-subtitle class="pb-0 pb-sm-2">
             {{ currentComplaintPosition.article.name }}
            </v-card-subtitle>
          </v-card>
        </v-card-title>
        <!-- koniec szczegółów pozycji reklamacji -->

        <!-- Żądanie z ikonami -->
        <!-- Żądanie -->
        <v-card-text class="px-1 pb-1">
          <v-card outlined class="px-2 mb-1">
            <v-row>
              <v-col
                class="col-7 col-sm-8 text-left text-sm-left mb-0 pl-4 pr-0 py-0"
                >
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0">
                    <v-list-item-subtitle class="overline mb-1">
                      {{ $t("ComplaintsList.ComplaintDocument.ComplaintRequest") }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="my-0 pl-sm-6 pr-0 mb-0 caption font-weight-thin"
                      >{{ $t(currentComplaintPosition.expectation.code) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              
              <!-- ikony -->
              <v-col
                class="col-5 col-sm-4 text-right text-sm-right py-0 pl-0 pr-4 my-0"
                >
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 px-0">
                    <v-list-item-title class="title px-0">
                      <v-icon 
                        class="px-1"
                        @click="openDialogHeaderBinaryList()"
                        v-if="ComplaintDocument.binariesDataList.length > 0"
                        small>
                          mdi-paperclip
                      </v-icon>
                      <v-chip 
                        class="px-2 px-sm-2"
                        x-small
                        :color="
                          getcomplaintStatusColor(
                            currentComplaintPosition.status,
                            ComplaintDocument.status,
                            currentComplaintPosition.hasNotice
                          )
                        "
                        dark
                        >{{
                          $t(
                            getcomplaintStatus(
                              currentComplaintPosition.status,
                              ComplaintDocument.status,
                              currentComplaintPosition.hasNotice
                            )
                          )
                        }}
                      </v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card>
                
          <!-- opis reklamacji -->
          <v-expansion-panels hover>
            <v-expansion-panel class="pa-0" >
              <v-expansion-panel-header v-slot="{ open }" class="px-3 py-0 text--secondary"> 
                <v-row no-gutters >
                  <v-col class="col-6 col-sm-2 pb-0 overline"> {{ $t("ComplaintsList.ComplaintDocument.ComplaintDescription") }}</v-col>
                  <v-col
                    class="col-6 col-sm-10 text--secondary pl-sm-1"
                  >
                    <v-fade-transition leave-absolute>
                      <span v-if="open"></span>
                      <v-row class="pt-1"
                        v-else
                        no-gutters
                        style="width: 100%"
                      >
                        <v-col cols="12" class="px-sm-2 text-truncate caption font-weight-thin">{{ComplaintDocument.description.substr(0,20)}}...</v-col>
                      </v-row>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
            <v-expansion-panel-content class="caption">
              <v-textarea
                auto-grow
                readonly
                class="caption font-weight-thin py-0 my-0"
                rows="1"
                rounded
                hide-details
                v-model="ComplaintDocument.description"
                >
              </v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
       
          <!-- realizacje -->
          <v-expansion-panels accordion hover focusable multiple title>
            <v-expansion-panel
              v-for="(item1, i) in currentComplaintPosition.realizationsList"
              :key="i"
              :readonly="!item1.description || false"
            >
              <v-expansion-panel-header class="px-3 pl-sm-5 py-0">
                <v-row>
                  <v-col class="col-4 col-sm-2 px-1 py-0">
                    <span class="overline">{{
                      item1.issueDate.slice(0, 10)
                    }}</span>
                  </v-col>
                  <v-col class="col-8 col-sm-10 px-1 py-0">
                    <span class="overline font-weight-bold ">
                     {{t_db("Realization", item1.name) }}
                    </span>
                  </v-col>
                </v-row>
                <template v-slot:actions>
                  <v-icon v-if="item1.description">mdi-menu-down</v-icon>
                  <v-icon v-else></v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <span class="caption font-weight-thin">
                {{item1.description}}
                </span>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <!-- Koniec listy realizacji -->

        <v-card-actions class="px-1 py-1">
         <v-spacer></v-spacer>
          <v-btn
            v-if="currentComplaintPosition.hasNotice"
            color="green darken-1"
            block
            :dark ="!btnCreateComplaintDisabled"
            @click="showDialogComplete = true"
            >{{ $t("Complete") }}</v-btn
          >


          <v-dialog
            v-model="showDialogComplete"
            max-width="50vw"
          >
            <v-card class="pt-0 pb-0">

              <v-card-title class="pa-1">
                <v-card color="primary" dark style="width: 100%">
                  <v-card-title class="pt-0 pb-2 pl-2 pr-1">
                    <span class="title font-weight-bold">
                      {{ $t("ComplaintsList.ComplaintDocument.ToComplete.TopicToComplete") }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon
                      color="blue darken-1" 
                      @click="closeDialogComplaintDocument()"
                      >mdi-close
                    </v-icon>
                  </v-card-title>
                  <v-card-subtitle class="pb-0 pb-sm-2">
                    {{ $t("ComplaintsList.ComplaintDocument.ToComplete.TopicToCompleteDescription") }}
                  </v-card-subtitle>
                </v-card>
              </v-card-title>

              <v-card-text>
                <v-textarea
                  v-model="txtComplete"
                  name="realization"
                  required
                  :label="lblAdditionalDescription"
                  :hint="lblAdditionalDescriptionHint"
                  
                  no-resize
                ></v-textarea>
              </v-card-text>


              <v-card-actions class="px-1 py-1">
                <v-btn
                  :disabled="btnSendToCompleteDisabled"
                  color="green darken-1"
                  block
                  :dark ="!btnSendToCompleteDisabled"
                  @click="sendRealization()"
                  >{{ $t("Send") }}</v-btn
                >
                <v-snackbar
                  :v-model="snackbarShow"
                  :timeout="snackbarTimeout"
                >
                  {{ this.snackbarText }}
                  <v-btn
                    :color="snackbarColor"
                    text
                    @click="snackbarShow = false"
                  >
                    Close
                  </v-btn>
                </v-snackbar>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-actions>
    </v-card>
  </v-dialog>
  </v-card>
 </v-dialog>
 <v-snackbar v-model="snack" :timeout="3000" :color="snackColor" text-align:center>
      {{ snackText }}
  </v-snackbar>
</v-container>
</template>

<script>
import axios from "axios";
import vuePdf from "vue-pdf";
import i18n from "../../i18n";

export default {
  components: {
    pdf: vuePdf
  },
  data() {
    return {
      lang: i18n.locale,
      startDate: "",
      startEnd: "",
      filterCustomer: "",
      menuStartDate: false,
      menuEndDate: false,

      showScroll: false,
      
      menuDateDoc: false,
      
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      snackbarShow: false,
      snackbarText: "",
      snackbarColor: "",
      snackbarTimeout: 3000,

      txtComplete: "",
      showFilter: true,
      autoHideFilter: false,
      alertGetData: false,

      NewRealization: {
        description: "",
        idx: ""
      },
      showDialogComplete: false,
      showDialogRealizationsList: false,
      currentComplaintPositionIdx: null,
      currentComplaintPosition: null,
      showRealizationDescriptionFull: true,

      snack: false,
      snackColor: "",
      snackText: "",

      search: "",

      showSelectPositions: false,
      showDialogComplaintDocument: false,
      showDialogHeaderBinaryList: false,
      showDialogInstalationAddress: false,

      showDialogFullAttachment: false,
      dataFullAttachment: null,

      btnSendToCompleteDisabled: true,

      binariesDataList: [],
      binariesData: {
        position: null,
        code: null,
        name: null,
        description: null,
        extension: null,
        typeId: null,
        data: null,
        idx: null
      },

      ComplaintsDocumentsList: [],
      ComplaintDocument: null,
      loading: false,

      selectedComplaintPositions: [],

      privileges: 0,

      currentPagePDF: 1,
      pageCountPDF: 0,

      filters: {
        code: []
      }
    };
  },
  beforeMount() {
    // Ustawianie cooki filtra
    if (this.$cookies.isKey("TPautoHideFilter") == true) {
      this.autoHideFilter = this.$cookies.get("TPautoHideFilter")
    } else 
      {this.$cookies.set("TPautoHideFilter", false)}
    
    if (this.$cookies.isKey("TPstartDate") == true) {
      if (this.$cookies.get("TPstartDate").constructor.toString().indexOf("Date") > -1) { this.startDate = this.$cookies.get("TPstartDate"); }  else { this.startDate=new Date().getFullYear() + '-01-01'; }
    }
    else
    {
      this.startDate=new Date().getFullYear() + '-01-01';  
      this.$cookies.set("TPstartDate",this.startDate);
    }
    if (this.$cookies.isKey("TPendDate") == true) {
      if (this.$cookies.get("TPendDate").constructor.toString().indexOf("Date") > -1) { this.endDate = this.$cookies.get("TPendDate"); }  else { this.endDate=new Date().toJSON().slice(0,10).replace(/-/g,'-'); }
    }
    else
    {
      this.endDate=this.endDate=new Date().toJSON().slice(0,10).replace(/-/g,'-');  
      this.$cookies.set("TPendDate",this.endDate);
    }
  },
  computed: {
    getstartDate: function() {
      return this.startDate;
    },
    getendDate: function() {
      return this.endDate;
    },
    lblDateFrom: function() {
      return this.$t("ComplaintsList.DateFrom");
    },
    lblDateTo: function() {
      return this.$t("ComplaintsList.DateTo");
    },
    lblCustomer: function() {
      return this.$t("ComplaintsList.Customer");
    },
    instalationAddres: function() {
      return this.ComplaintDocument.instalationAddress
        ? this.ComplaintDocument.instalationAddress.replace(
            /.,/g,
            String.fromCharCode(13)
          )
        : "";
    },
    lblAdditionalDescription: function() {
      return this.$t("ComplaintsList.ComplaintDocument.ToComplete.AdditionalDescription");
    },
    lblAdditionalDescriptionHint: function() {
      return this.$t("ComplaintsList.ComplaintDocument.ToComplete.AdditionalDescriptionInfo");
    },
    lblBtnMore: function(){
      if (this.showRealizationDescriptionFull) {
        return this.$t("More");
      }
      else
      {
        return this.$t("Less");
      }
    },
    lblDocumentsFrom: function() {
      return this.$t("ComplaintsList.DocumentsFrom");
    },
    lblSearch: function() {
      return this.$t("Search");
    },
    LblLoading: function() {
      return this.$t("Loading");
    },
    headerComplaintsView() {
      return [
        {
          text: this.$t("ComplaintsList.ComplaintsList.documentNumber"),
          align: "start",
          value: "documentNumber.documentFullName",
          class: ".d-sm-none .d-md-flex",
        },
        {
          text: this.$t("ComplaintsList.ComplaintsList.mainCustomer"),
          value: "mainCustomer.code",
          align: window.Store.getters.getPriviliges == 0 ? " d-none" : ""
        },
        {
          text: this.$t("ComplaintsList.ComplaintsList.transactionalDocumentNumber"),
          value: "transactionalDocumentNumber.documentFullName",
          visibility: 'hidden-sm-and-down'
        },
        {
          text: this.$t("ComplaintsList.ComplaintsList.orderDocumentNumber"),
          value: "orderDocumentNumber.foreignDocument",
          visibility: 'hidden-sm-only'
        },
        {
          text: this.$t("ComplaintsList.ComplaintsList.targetCustomer"),
          value: "targetCustomer.name",
          
        },
        {
          text: this.$t("ComplaintsList.ComplaintsList.complaintDate"),
          align: "center",
          value: "issueDate"
        },
        {
          text: this.$t("ComplaintsList.ComplaintsList.complaintStatus"),
          align: "center",
          value: this.$t("complaintStatus")
        }
      ];
    },
    headerComplaintPositions() {
      return [
        {
          text: this.$t("Orders.Positions.Position"),
          align: "center",
          value: "position"
        },
        {
          text: this.$t("Orders.Positions.Code"),
          value: "article.code"
        },
        {
          text: this.$t("Orders.Positions.Quanity"),
          align: "center",
          value: "quantity"
        }
      ];
    }
  },
  methods: {
     t_db(key,value) {
      var text = '';

      if (value != '') {
        if (this.$t(`${key}.${value}`) == `${key}.${value}`)
          {text = `${value} - noTranslateKey_${key}.${value}`}
        else text= this.$t(`${key}.${value}`)}
      return text;
    },
    
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||  e.target.scrollTop || 0
      this.showScroll = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },
    myEventHandler() {
      this.setComplaintDescription();
    },
    getComplaintDescriptionLettersCount() {
      var w = window.innerWidth;
      var l = 0;
      if (w<320)  { l = w / 11 }
      else if (w==320)  { l = 32 }
      else if (w > 320 && w < 360)  { l = w / 10 }
      else if (w==360)  { l = 40}
      else if (w > 360 && w < 375)  { l = w / 9.5}
      else if (w==375)  { l = 45}
      else if (w > 375 && w < 411)  { l = w / 9 }
      else if (w==411)  { l = 50}
      else if (w > 411 && w < 414)  { l = w / 8.5 }
      else if (w==414)  { l = 50}
      else if (w > 414 && w < 430)  { l = w / 8.2 }
      else if (w > 430 && w < 480)  { l = w / 7.9 }
      else if (w >= 480 && w < 586)  { l = w / 7.5 }
      else if (w >= 586 && w < 768)  { l = w / 7.3 }
      else if (w==768)  { l = 110}
      else if (w > 768 && w < 1024)  { l = w / 7 }
      else if (w >= 1024 && w < 1340)  { l = w / 6.7 }
      else if (w >= 1340)  { l = w / 6.5 }

      return l;
    },
    setComplaintDescription() {
      var maxSize = this.getComplaintDescriptionLettersCount();
      this.ComplaintDocument.descriptionSmall="";
      if (this.ComplaintDocument.description.indexOf("\n") > 0) {
        if (this.ComplaintDocument.description.length > maxSize){
          this.ComplaintDocument.descriptionSmall = this.ComplaintDocument.description.substr(0, maxSize);
        }
        else{
          this.ComplaintDocument.descriptionSmall = this.ComplaintDocument.description.substr(0,this.ComplaintDocument.description.indexOf("\n") - 1);
        }
      } else if (this.ComplaintDocument.description.length > maxSize) {
        this.ComplaintDocument.descriptionSmall = this.ComplaintDocument.description.substr(0, maxSize);
      } else {
        this.ComplaintDocument.descriptionSmall = this.ComplaintDocument.description;
      }
      this.$forceUpdate();
    },
    openSnackBar(txt, color, timeout) {
      if (timeout) this.snackbarTimeout = timeout;
      else this.snackbarTimeout = 3000;

      this.snackbarColor = color;
      this.snackbarText = txt;
      this.snackbarShow = true;
    },
    sendRealization() {
      this.NewRealization.description = this.txtComplete;
      this.NewRealization.idx = this.currentComplaintPositionIdx;

      // wyslij przez API
      if (this.postNewRealization(this.NewRealization)) {
        this.openSnackBar("Uzupełnienie reklamacji zostało wysłane", "green", 2000);
        this.showDialogComplete = false;
        this.showDialogRealizationsList = false;
        this.closeDialogComplaintDocument();
        this.getComplaintsDocumentsView();
      } else {
        this.openSnackBar("Coś poszło nie tak", "red", 3000);
      }
      // wyczysc NewRealization
    },
    showDialogPositionRealization(obj) {
      this.showDialogComplaintDocument = false;
      this.showDialogRealizationsList = true,
      this.currentComplaintPosition = obj,
      this.currentComplaintPositionIdx = obj.idx;
    },
    closeDialogPositionRealization() {
      this.showDialogRealizationsList = false,
      this.showDialogComplaintDocument = true;
      this.currentComplaintPosition = null,
      this.currentComplaintPositionIdx = null;
    },
    // element tablicy realizacji -> string
    realizationsElement(obj) {
      var date = obj.issueDate.slice(0, 10);
      var name = obj.name;
      var result = date + " " + name;
      return result;
    },

    // ostatni element tablicy realizacji -> string
    lastRealizationsElement(arr) {
      var lastElement = arr[arr.length - 1];
      var date = lastElement.issueDate.slice(0, 10);
      var name = lastElement.name;
      var result = date + " " + name;
      return result;
    },
    // Okienko z pozycjami dokumentu
    openDialogComplaintDocument: function(selected) {
      this.selectedComplaintPositions = [];
      this.getComplaintsDocuments(selected.idx);
      this.showDialogComplaintDocument = true;
    },
    closeDialogComplaintDocument() {
      this.ComplaintDocument = null;
      this.selectedComplaintPositions = [];
      this.showDialogComplaintDocument = false;
    },
    closeComplaintList(){
      this.$router.push("/");
    },
    getfirstLetterFromString(string) {
      var stringtmp;
      if (string.length > 0) {
        stringtmp = string.substr(0,1);
      }
      else{
        stringtmp = "";
      }
      return stringtmp;
    },
    getStateIco(state) {
      if (state === "Closed") return "mdi-lock";
      else return "mdi-lock-open-outline";
    },
    getcomplaintStatusColor(state, confirm, hasNotice) {
      if (hasNotice) return "red darken-3";
      else if (confirm == "UnConfirmed") return "grey darken-1";
      else if (state === "Considered") return "green darken-1";
      else if (state === "Rejected") return "deep-orange darken-4";
      else if (state === "UnderExamination") return "light-blue darken-3";
      else return "green darken-4";
    },
    getcomplaintStatus(state, confirm, hasNotice) {
      if (hasNotice) return "To Complete";
      else if (confirm == "UnConfirmed") return "Introduced";
      else return state;
    },
    dateFormat: function(date) {
      return date.slice(0, 10);
    },
    getAttachmentData(type) {
      if (type == "PDF") {
        return "data:application/pdf;base64, " + this.dataFullAttachment.data;
      }
      else
      {
        return "data:image/jpeg;base64, " + this.dataFullAttachment.data;
      }
    },
    saveAttachmentToDisc(){
      const downloadLink = document.createElement("a");
      const fileName = this.dataFullAttachment.name;
      if (this.dataFullAttachment.typeId == 858 || this.dataFullAttachment.typeId == 859) {
        downloadLink.href = "data:application/pdf;base64," + this.dataFullAttachment.data;
      }
      else
      {
        downloadLink.href = "data:image/jpeg;base64," + this.dataFullAttachment.data;
      }
      downloadLink.download = fileName;
      downloadLink.click();

    },
    openDialogInstalationAddress() {
      this.showDialogInstalationAddress = true;
    },
    closeDialogInstalationAddress() {
      this.showDialogInstalationAddress = false;
    },
    openDialogFullAttachment(item) {
      this.dataFullAttachment = item;
      this.showDialogHeaderBinaryList = false;
      this.showDialogFullAttachment = true;
    },
    closeDialogFullAttachment() {
      this.showDialogFullAttachment = false;
      
      this.showDialogHeaderBinaryList = true;
    },
     dataImageUrl(binariesData) {
      return "data:image/jpeg;base64, " + binariesData;
    },
    async refreshDocList() {

      this.alertGetData = true;
      this.loading = true;

      this.$cookies.set("TPautoHideFilter", this.autoHideFilter);
      this.$cookies.set("TPstartDate", this.startDate);
      this.$cookies.set("TPendDate", this.endDate);
      
      var startDate = new Date(this.startDate);
      var endDate = new Date(this.endDate);

      if (endDate < startDate) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = this.$t("NewComplaint.SearchError2");
      }
      else{
        this.loading = true;
        this.ComplaintsDocumentsList = [];
        const Mask = {
                startDate: this.getstartDate,
                endDate: this.getendDate,
                series: "",
                status: "All",

              };
          await this.getComplaintsDocumentsView(Mask)
        this.loading = false;
      }
      if (this.autoHideFilter) {this.showFilter = false}
      this.alertGetData = false;
      this.loading = false;
      
    },
    //API - pobieranie listy Reklamacji
    async getComplaintsDocumentsView(Mask) {
      return new Promise((resolve, reject) => {
        window.Store.dispatch("sessionAuthorise").then(response => {
          if (response.respond == "logged") {
            axios
              .post(
                window.API.ComplaintsDocumentsView,
                Mask,
                window.Store.getters.getAxiosHeader
              )
              .then(response => {
                this.loading = false;
                this.ComplaintsDocumentsList = response.data;
                resolve();
              })
              .catch(errors => {
                const errorStatus = errors.response;
                if (errorStatus == 401) {
                  window.Store.dispatch("logout");
                }
                reject(errors)
              });
          } else {
            window.Store.dispatch("logout");
          }
        });
      })
    },
    //API - wysyłanie nowej realizacji do pozycji
    async postNewRealization(Realization) {
      window.Store.dispatch("sessionAuthorise").then(response => {
        if (response.respond == "logged") {
          axios
            .post(
              window.API.NewRealization,
              Realization,
              window.Store.getters.getAxiosHeader
            )
            .then(response => {
              this.ComplaintExpectationTable = response.data;
            })
            .catch(errors => {
              const errorStatus = errors.response;
              if (errorStatus == 401) {
                window.Store.dispatch("logout");
              }
            });
        } else {
          window.Store.dispatch("logout");
        }
      });
    },
    //API - pobieranie dokumentu Reklamacji
    async getComplaintsDocuments(idx) {
      window.Store.dispatch("sessionAuthorise").then(response => {
        if (response.respond == "logged") {
          axios
            .get(
              window.API.ComplaintsDocuments + "/" + idx + "/" + window.Store.getters.getLang,
              window.Store.getters.getAxiosHeader
            )
            .then(response => {
              this.ComplaintDocument = response.data;
              this.myEventHandler();
            })
            .catch(errors => {
              const errorStatus = errors.response;
              if (errorStatus == 401) {
                window.Store.dispatch("logout");
              }
            });
        } else {
          window.Store.dispatch("logout");
        }
      });
    },
    //API -pbieranie danych z BinariesData
    async getBinariesData(idx) {
      this.binariesData = [];
      return new Promise((resolve, reject) => {
        window.Store.dispatch("sessionAuthorise").then(response => {
          if (response.respond == "logged") {
            axios
              .get(
                window.API.BinariesData + "/" + idx,
                window.Store.getters.getAxiosHeader
              )
              .then(response => {
                resolve(response.data);
              })
              .catch(errors => {
                reject(errors);
              });
          } else {
            window.Store.dispatch("logout");
          }
        });
      });
    },
    //API -pbieranie listy BinariesData dla pozycji
    async openDialogHeaderBinaryList() {
      return new Promise(resolve => {
        this.binariesDataList = [];
        this.ComplaintDocument.binariesDataList.forEach(item => {
          this.getBinariesData(item.idx).then(response => {
            this.binariesDataList.push(response);
            resolve(response);
          });
        });
        this.showDialogHeaderBinaryList = true;
      });
    },
    closeDialogHeaderBinaryList() {
      this.showDialogHeaderBinaryList = false;
    },
  },
  mounted() {
    this.privileges = window.Store.getters.getPriviliges;
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  watch: {
    txtComplete () {
      if(this.txtComplete.length > 0) {
        this.btnSendToCompleteDisabled = false;
       }
       else{
        this.btnSendToCompleteDisabled = true;
       }
    }
  }

};
</script>
